import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'

const CloudSettingsRoute = () => (
  <Suspense fallback={<div />}>
    <Outlet />
  </Suspense>
)

export default CloudSettingsRoute
